import React from 'react';
import { Card, Statistic } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import './SalesCard.scss';

const SalesCard = ({ 
  title, 
  value, 
  prefix = 'R$', 
  precision = 2, 
  trend, 
  trendValue, 
  loading = false,
  className = ''
}) => {
  const formatValue = (val) => {
    if (typeof val === 'number') {
      return val.toLocaleString('pt-BR', {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
      });
    }
    return val;
  };

  const getTrendIcon = () => {
    if (!trend) return null;
    return trend === 'up' ? <ArrowUpOutlined /> : <ArrowDownOutlined />;
  };

  const getTrendColor = () => {
    if (!trend) return undefined;
    return trend === 'up' ? '#3f8600' : '#cf1322';
  };

  return (
    <Card 
      className={`sales-card ${className}`}
      loading={loading}
      size="small"
    >
      <Statistic
        title={title}
        value={formatValue(value)}
        prefix={prefix}
        valueStyle={{ 
          color: '#1890ff',
          fontSize: '24px',
          fontWeight: 'bold'
        }}
        suffix={
          trend && (
            <div className="trend-indicator">
              <span 
                style={{ 
                  color: getTrendColor(),
                  fontSize: '14px',
                  marginLeft: '8px'
                }}
              >
                {getTrendIcon()} {trendValue}%
              </span>
            </div>
          )
        }
      />
    </Card>
  );
};

export default SalesCard;
